import { Component, OnInit } from '@angular/core';
import { MetaService } from 'services/meta.service';

@Component({
	selector: 'ras-privacy-statement-page',
	templateUrl: './privacy-statement-page.component.html',
	styleUrls: ['./privacy-statement-page.component.sass']
})
export class PrivacyStatementPageComponent implements OnInit {

	constructor(private metaService: MetaService) { }

	ngOnInit() {
		this.metaService.apply('privacy')
	}

}
